<div [hidden]="!show" id="myModal" class="modal" (click)="onBackgroundClickClose($event)">
    <div class="modal-content">
        <div class="modal-header">
            <span class="close" (click)="onClose()">&times;</span>
            <h2> {{ 'label.moreInfo' | translate }}</h2>
        </div>
        <div class="modal-body" *ngIf="modalHistoryItem">
            <table>
                <ng-container *ngFor="let item of modalHistoryItem.Items">
                    <tr>
                        <td>
                            {{ 'label.fullAmount' | translate }}
                        </td>
                        <td>
                            {{modalHistoryItem.Amount}} {{modalHistoryItem.Currency}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{item.ProviderName}}
                        </td>
                        <td>
                            {{item.UniqId}}
                        </td>
                    </tr>
                    <tr *ngFor="let itemInputs of item.ItemInputs">
                        <td>
                            {{itemInputs.InputName}}
                        </td>
                        <td>
                            {{itemInputs.Value}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ 'label.amount' | translate }}
                        </td>
                        <td>
                            {{item.Amount}} {{item.Currency}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ 'label.commission' | translate }}
                        </td>
                        <td>
                            {{item.Commission}} {{item.Currency}}
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>{{ 'label.date' | translate }}</td>
                    <td>{{modalHistoryItem.CreationDate | date:'dd-MM-yyyy'}}</td>
                </tr>
                <ng-container *ngFor="let item of modalHistoryItem.Items">
                    <tr>
                        <td>{{ 'label.state' | translate }}</td>
                        <td>{{getStatus(item.State)}}</td>
                    </tr>
                </ng-container>
            </table>
        </div>
    </div>
</div>